import ReactDOM from 'react-dom';
var Portal = function (props) {
    var _a = props.container, container = _a === void 0 ? document.body : _a, children = props.children;
    return ReactDOM.createPortal(children, container);
};
export default Portal;
//# sourceMappingURL=index.js.map